<template>
	<div class="juniper-container" :class="{ 'dashboard-dark': dashboardDark, 'juniper-container--no-sidebar': hideSidebarForRoute }">
		<JuniperSidebar v-if="!hideSidebarForRoute" @toggle="onSidebarToggle" />
		<div class="juniper-content" :class="{ 'sidebar-collapsed': sidebarCollapsed && !hideSidebarForRoute, 'no-sidebar': hideSidebarForRoute }">
			<div class="juniper-scrollable">
				<div :class="contentWrapperClass">
					<router-view></router-view>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import JuniperSidebar from '@/components/juniper/layout/Sidebar.vue'
import { mapGetters, mapState } from 'vuex'
export default {
	name: 'JuniperDashboard',
	components: { JuniperSidebar },
	data() {
		return {
			sidebarCollapsed: localStorage.getItem('juniper-sidebar-collapsed') === 'true',
		}
	},
	computed: {
		...mapState(['authUser', 'dashboardDark']),
		...mapGetters(['isAuth']),
		hideSidebarForRoute() {
			return [
				'juniperClientCustomizer',
				'juniperClientCustomizer2',
				'juniperClientLandingPageCustomizer',
			].includes(this.$route.name)
		},
		// Wrapper width per route:
		//  - customizer pages: full-bleed host (sidebar already hidden)
		//  - client edit (has its own full-width hero/container): keep full width
		//  - everything else (Settings, Menus, Deploy, …): centered .container
		fullWidthForRoute() {
			return [
				'juniperClients',
				'juniperClientEdit',
				'juniperClientEditBusiness',
				'juniperDebugging',
				'juniperLogs',
				'juniperAccessibilityStats',
				'juniperAccessibilityClientStats',
			].includes(this.$route.name)
		},
		contentWrapperClass() {
			if (this.hideSidebarForRoute) return 'juniper-view-host juniper-view-host--full'
			if (this.fullWidthForRoute) return 'container-fluid py-3 pb-5'
			return 'container py-3 pb-5'
		},
	},
	mounted() {
		this.syncDashboardTheme(this.dashboardDark)
	},
	beforeDestroy() {
		document.body.classList.remove('dashboard-dark')
	},
	watch: {
		dashboardDark(newValue) {
			this.syncDashboardTheme(newValue)
		},
	},
	methods: {
		onSidebarToggle(collapsed) {
			this.sidebarCollapsed = collapsed
		},
		syncDashboardTheme(isDark) {
			document.body.classList.toggle('dashboard-dark', isDark)
		},
	},
}
</script>

<style scoped>
.juniper-container {
	display: flex;
	height: 100vh;
	overflow: hidden;
	width: 100%;
}

.juniper-content {
	flex: 1;
	margin-left: 200px;
	transition: margin-left 0.3s ease;
	display: flex;
	flex-direction: column;
	height: 100vh;
	overflow: hidden;
}

.juniper-content.sidebar-collapsed {
	margin-left: 60px;
}

.juniper-content.no-sidebar {
	margin-left: 0;
}

.juniper-scrollable {
	flex: 1;
	overflow-y: auto;
	overflow-x: hidden;
}

.juniper-view-host--full {
	padding: 0 !important;
	margin: 0 !important;
	width: 100%;
	min-height: 100%;
}

@media (max-width: 768px) {
	.juniper-content {
		margin-left: 0 !important;
	}
}
</style>
